"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifyObjValues = exports.positiveOrZero = exports.findDOMNode = void 0;
function findDOMNode(component) {
  return component;
}
exports.findDOMNode = findDOMNode;
function positiveOrZero(number) {
  return number < 0 ? 0 : number;
}
exports.positiveOrZero = positiveOrZero;
function modifyObjValues(obj) {
  var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  var modifiedObj = {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) modifiedObj[key] = modifier(obj[key]);
  }
  return modifiedObj;
}
exports.modifyObjValues = modifyObjValues;